import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ModalEditarHora from './ModalEditarHora'; 

const MarcajesRRHH = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [respuesta, setRespuesta] = useState(null);
  const [jsonRecibido, setJsonRecibido] = useState(null);
  const [fechaSeleccionada, setFechaSeleccionada] = useState('');
  const [fechaSeleccionada2, setFechaSeleccionada2] = useState('');
  const [detallesAbiertos, setDetallesAbiertos] = useState({});

  // Estados para los filtros
  const [filtroNombre, setFiltroNombre] = useState('');
  const [filtroCompania, setFiltroCompania] = useState('');
  const [filtroUnidad, setFiltroUnidad] = useState('');
  const [filtroPuesto, setFiltroPuesto] = useState('');
  const [filtroArea, setFiltroArea] = useState(''); 
  const [filtroCodigo, setFiltroCodigo] = useState('');
  const [filtroHorasNegativas, setFiltroHorasNegativas] = useState(false);
  const [minutosARestar, setMinutosARestar] = useState(0); 
  const [minutosRealesAcumulados, setMinutosRealesAcumulados] = useState({});
  const [minutosDescontados, setMinutosDescontados] = useState({});

  const [restarMinutosFaltantes, setRestarMinutosFaltantes] = useState(false);

  // Estados para la selección de elementos
  const [seleccionados, setSeleccionados] = useState({}); // Almacena los códigos seleccionados
  const [seleccionarTodos, setSeleccionarTodos] = useState(false); // Estado para seleccionar/deseleccionar todos

  // Estado para las horas seleccionadas
  const [horasSeleccionadas, setHorasSeleccionadas] = useState({}); // Almacena las horas aprobadas/rechazadas  


  const [showModal, setShowModal] = useState(false);
  const [horaEditando, setHoraEditando] = useState({
    codigo: '',
    index: 0,
    tipo: '', // 'E' o 'S'
    segmento: 1,
    horaActual: '',
    fecha: ''
  }); 
  const handleEditarHora = (codigo, index, segmento, tipo, horaActual, fecha) => {
    setHoraEditando({
      codigo,
      index,
      segmento,
      tipo,
      horaActual,
      fecha
    });
    setShowModal(true);
  };

  const handleGuardarCambios = async (datosEditados) => {
    const { codigo, index, segmento, tipo, horaActual, fecha } = datosEditados;
    
    // Crear el JSON específico para Datos_Recibidos
    const datosRecibidos = {
      CodUsu: codigo,
      Segmento: segmento.toString(),
      Frecuencia: tipo, // 'E' o 'S'
      Fecha: fecha.replace(/-/g, ''), // Formato YYYYMMDD
      tiempo: horaActual
    };
  
    // Crear el objeto completo para la petición POST 
    console.log(datosRecibidos)
    const postData = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "motorola",
        Modelo: "moto g54 5G",
        Version: "14",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "-90.509232|14.5903641|0"
      },
      User: {
        Codigo: "",
        UserNickName: "Pierril"
      },
      Metodo: {
        NombreMetodo: "ActualizarMarcaEnSabana",
        Datos_Recibidos: JSON.stringify(datosRecibidos), // Convertir a string
        datos_Generados: ""
      }
    };
  
    try {
      setLoading(true);
      console.log(postData)
      const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData)
      });
  
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
  
      const data = await response.json();
      console.log("Respuesta del servidor:", data);
  
      // Actualizar el estado local solo si la API responde con éxito
      const nuevosDatos = { ...respuesta };
      const key = tipo === 'E' ? `HoraE${segmento}` : `HoraS${segmento}`;
      nuevosDatos[codigo][index][key] = horaActual;
      setRespuesta(nuevosDatos);
  
      alert("Hora actualizada correctamente");
    } catch (error) {
      console.error("Error al actualizar la hora:", error);
      alert("Error al actualizar la hora: " + error.message);
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  // Función para calcular las horas extras seleccionadas por jornada y tipo
  const calcularSumaHorasSeleccionadas = (codigo) => {
    if (!respuesta || !respuesta[codigo]) return {
      diurnaSimple: "0.00",
      diurnaDoble: "0.00",
      mixtaSimple: "0.00",
      mixtaDoble: "0.00",
      minutosFaltantes: 0
    };
  
    // 1. Obtener minutos faltantes por jornada
    const { porJornada1 } = calcularMinutosPorJornada(codigo);
    
    // 2. Inicializar acumuladores por tipo
    const horasExtras = {
      Diurna: { simple: 0, doble: 0 },
      Mixta: { simple: 0, doble: 0 }
    };
  
    // 3. Sumar horas extras seleccionadas (con precisión de 2 decimales)
    Object.keys(horasSeleccionadas).forEach((key) => {
      if (!horasSeleccionadas[key]) return;
  
      const [codigoEmpleado, index] = key.split('-');
      if (codigoEmpleado !== codigo || index >= respuesta[codigo].length) return;
  
      const marcaje = respuesta[codigo][index];
      const horas = parseFloat(parseFloat(marcaje.HorasExtra).toFixed(2)) || 0;
      const tipo = marcaje.Tipo_Hora_Extra?.toUpperCase();
      const jornada = marcaje.Jornada === "Mixta" ? "Mixta" : "Diurna";
  
      if (tipo === "SIMPLE") {
        horasExtras[jornada].simple = parseFloat((horasExtras[jornada].simple + horas).toFixed(2));
      } else if (tipo === "DOBLE") {
        horasExtras[jornada].doble = parseFloat((horasExtras[jornada].doble + horas).toFixed(2));
      }
    });
  
    // 4. Crear copia para no modificar el original
    let horasExtrasFinal = {
      Diurna: { ...horasExtras.Diurna },
      Mixta: { ...horasExtras.Mixta }
    };
  
    // 5. Aplicar descuento SOLO SI el checkbox está marcado
    if (restarMinutosFaltantes) {
      porJornada1.forEach(jornada => {
        const minutosFaltantes = Math.abs(jornada.descontados);
        const horasFaltantes = parseFloat((minutosFaltantes / 60).toFixed(2));
  
        if (jornada.tipo === "Diurna") {
          // Descontar primero de las horas simples
          const aDescontarSimple = Math.min(horasExtrasFinal.Diurna.simple, horasFaltantes);
          horasExtrasFinal.Diurna.simple = parseFloat((horasExtrasFinal.Diurna.simple - aDescontarSimple).toFixed(2));
          
          // Luego de las dobles si aún hay faltantes
          const faltantesRestantes = parseFloat((horasFaltantes - aDescontarSimple).toFixed(2));
          if (faltantesRestantes > 0) {
            horasExtrasFinal.Diurna.doble = parseFloat((horasExtrasFinal.Diurna.doble - Math.min(horasExtrasFinal.Diurna.doble, faltantesRestantes)).toFixed(2));
          }
        } 
        else if (jornada.tipo === "Mixta") {
          // Descontar primero de las horas simples
          const aDescontarSimple = Math.min(horasExtrasFinal.Mixta.simple, horasFaltantes);
          horasExtrasFinal.Mixta.simple = parseFloat((horasExtrasFinal.Mixta.simple - aDescontarSimple).toFixed(2));
          
          // Luego de las dobles si aún hay faltantes
          const faltantesRestantes = parseFloat((horasFaltantes - aDescontarSimple).toFixed(2));
          if (faltantesRestantes > 0) {
            horasExtrasFinal.Mixta.doble = parseFloat((horasExtrasFinal.Mixta.doble - Math.min(horasExtrasFinal.Mixta.doble, faltantesRestantes)).toFixed(2));
          }
        }
      });
    }
  
    // 6. Retornar resultados
    return {
      diurnaSimple: Math.max(0, horasExtrasFinal.Diurna.simple).toFixed(2),
      diurnaDoble: Math.max(0, horasExtrasFinal.Diurna.doble).toFixed(2),
      mixtaSimple: Math.max(0, horasExtrasFinal.Mixta.simple).toFixed(2),
      mixtaDoble: Math.max(0, horasExtrasFinal.Mixta.doble).toFixed(2),
      minutosFaltantes: porJornada1.reduce((sum, j) => sum + j.reales, 0),
      aplicadoDescuento: restarMinutosFaltantes // Opcional: para mostrar en la UI si se aplicó descuento
    };
  };
 
  // Función auxiliar para restar minutos faltantes
  function restarFaltantesDeHoras(horasObj, minutosFaltantes) {
    const horasFaltantes = minutosFaltantes / 60;
    
    // Ordenar jornadas por horas disponibles (mayor a menor)
    const jornadas = Object.entries(horasObj)
      .filter(([_, horas]) => horas > 0)
      .sort((a, b) => b[1] - a[1]);
  
    if (jornadas.length === 0) return; // No hay horas para descontar
  
    // Restar de la jornada con más horas primero
    let faltantesPorRestar = horasFaltantes;
    for (const [jornada, horas] of jornadas) {
      if (faltantesPorRestar <= 0) break;
      
      const aRestar = Math.min(horas, faltantesPorRestar);
      horasObj[jornada] -= aRestar;
      faltantesPorRestar -= aRestar;
    }
  }
  
  // Formatear salida a 2 decimales
  function formatHoras(horasObj) {
    return {
      diurnaSimple: horasObj.diurnaSimple.toFixed(2),
      diurnaDoble: horasObj.diurnaDoble.toFixed(2),
      mixtaSimple: horasObj.mixtaSimple.toFixed(2),
      mixtaDoble: horasObj.mixtaDoble.toFixed(2),
    };
  }

  const enviarDatos = async () => {
    setLoading(true);
    setError(null);
    setRespuesta(null);
    setJsonRecibido(null);

    if (!fechaSeleccionada) {
      setError('Por favor, selecciona una fecha.');
      setLoading(false);
      return;
    }

    const fechaFormateada = fechaSeleccionada.replace(/-/g, '');
    const fechaFormateada2 = fechaSeleccionada2.replace(/-/g, '');
    const datos = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      Usr: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      DatosMetodo: {
        NombreMetodo: 'ListaMarcasEmpleadosBiometrico',
        Datos_Recibidos: JSON.stringify({ FechaIni: fechaFormateada, FechaFin: fechaFormateada2, CodEmp: filtroCodigo, Nombre: filtroNombre,Area: filtroArea,Unidad: filtroUnidad}),
      },
    };

    console.log(datos)
    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;

    try {
      const response = await fetch(fetchDataUrl);
      const data = await response.json();
      console.log('Respuesta de la API:', data);

      setJsonRecibido(data);

      if (data.datos_Generados) {
        const datosGenerados = JSON.parse(data.datos_Generados);
        console.log('Datos Generados (JSON):', datosGenerados);

        if (typeof datosGenerados.MARCAS === 'string') {
          datosGenerados.MARCAS = JSON.parse(datosGenerados.MARCAS);
        }

        // Agrupar los datos por exp_codigo_alternativo
        const datosAgrupados = datosGenerados.MARCAS.reduce((acc, marcaje) => {
          const codigo = marcaje.exp_codigo_alternativo;
          if (!acc[codigo]) {
            acc[codigo] = [];
          }
          acc[codigo].push(marcaje);
          return acc;
        }, {});

        setRespuesta(datosAgrupados);
      } else {
        setError('No se encontraron datos generados en la respuesta.');
      }
    } catch (error) {
      console.error('Error al procesar la respuesta:', error);
      setError('Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }
  };

  const toggleDetalles = (codigo) => {
    setDetallesAbiertos((prev) => ({
      ...prev,
      [codigo]: !prev[codigo],
    }));
  };

  // Función para filtrar los datos
  const filtrarDatos = (datos) => {
    return Object.keys(datos).filter((codigo) => {
      const empleado = datos[codigo][0];
      const cumpleFiltros = (
        empleado.exp_apellidos_nombres.toLowerCase().includes(filtroNombre.toLowerCase()) &&
        empleado.cia_descripcion.toLowerCase().includes(filtroCompania.toLowerCase()) &&
        empleado.uni_descripcion.toLowerCase().includes(filtroUnidad.toLowerCase()) &&
        empleado.pue_nombre.toLowerCase().includes(filtroPuesto.toLowerCase()) &&
        empleado.arf_nombre.toLowerCase().includes(filtroArea.toLowerCase()) &&
        empleado.exp_codigo_alternativo.toLowerCase().includes(filtroCodigo.toLowerCase())
      );
  
      // Si el filtro de horas negativas está activo, solo mostrar empleados con horas negativas
      if (filtroHorasNegativas) {
        return cumpleFiltros && tieneHorasNegativas(codigo);
      }
  
      // Si no, mostrar todos los empleados que cumplan los filtros
      return cumpleFiltros;
    });
  }; 

  const tieneHorasNegativas = (codigo) => {
    return respuesta[codigo].some((marcaje) => {
      const horasExtras = parseFloat(marcaje.HorasExtra);
      return !isNaN(horasExtras) && horasExtras < 0;
    });
  };

  // Función para manejar la selección individual de empleados y sus horas
  const handleSeleccionar = (codigo) => {
    const estaSeleccionado = !seleccionados[codigo];
    setSeleccionados((prev) => ({
      ...prev,
      [codigo]: estaSeleccionado,
    }));

    // Seleccionar o deseleccionar todas las horas del empleado
    const nuevasHorasSeleccionadas = { ...horasSeleccionadas };
    respuesta[codigo].forEach((_, index) => {
      nuevasHorasSeleccionadas[`${codigo}-${index}`] = estaSeleccionado;
    });
    setHorasSeleccionadas(nuevasHorasSeleccionadas);
  };

  // Función para manejar la selección/deselección de todos los empleados y sus horas
  const handleSeleccionarTodos = () => {
    const nuevosSeleccionados = {};
    const nuevasHorasSeleccionadas = { ...horasSeleccionadas };

    if (!seleccionarTodos) {
      // Seleccionar todos los empleados y sus horas
      Object.keys(respuesta).forEach((codigo) => {
        nuevosSeleccionados[codigo] = true;
        respuesta[codigo].forEach((_, index) => {
          nuevasHorasSeleccionadas[`${codigo}-${index}`] = true;
        });
      });
    } else {
      // Deseleccionar todos los empleados y sus horas
      Object.keys(respuesta).forEach((codigo) => {
        nuevosSeleccionados[codigo] = false;
        respuesta[codigo].forEach((_, index) => {
          nuevasHorasSeleccionadas[`${codigo}-${index}`] = false;
        });
      });
    }

    setSeleccionados(nuevosSeleccionados);
    setHorasSeleccionadas(nuevasHorasSeleccionadas);
    setSeleccionarTodos(!seleccionarTodos);
  };

  // Función para manejar la selección de horas individuales
  const handleSeleccionarHora = (codigo, index) => {
    setHorasSeleccionadas((prev) => ({
      ...prev,
      [`${codigo}-${index}`]: !prev[`${codigo}-${index}`],
    }));
  };

  // Función para procesar los elementos seleccionados
  const procesarSeleccionados = () => {
    const elementosProcesar = Object.keys(seleccionados).filter(
      (codigo) => seleccionados[codigo]
    );
    console.log("Elementos a procesar:", elementosProcesar);
    // Aquí puedes agregar la lógica para procesar los elementos seleccionados
    procesarHorasSeleccionadas()
  };

  // Función para procesar todas las horas seleccionadas
 /* const procesarHorasSeleccionadas = () => {
    const horasProcesar = Object.keys(horasSeleccionadas).filter(
      (key) => horasSeleccionadas[key]
    );

    // Filtrar solo las horas marcadas
    const horasMarcadas = horasProcesar.map((key) => {
      const [codigo, index] = key.split('-');
      return respuesta[codigo][index];
    });

    console.log("Horas a procesar:", horasMarcadas);
    // Aquí puedes agregar la lógica para procesar las horas seleccionadas
  };*/

  // Función para procesar todos los elementos
  const procesarTodos = () => {
    console.log("Procesando todos los elementos");
    procesarHorasSeleccionadas()
    // Aquí puedes agregar la lógica para procesar todos los elementos
  }; 

  const procesarHorasSeleccionadas = async () => {
    if (!respuesta) {
      console.error("No hay datos de respuesta disponibles.");
      return;
    }
  
    const horasProcesar = Object.keys(horasSeleccionadas).filter(
      (key) => horasSeleccionadas[key]
    );
  
    // Filtrar solo las horas marcadas
    const horasMarcadas = horasProcesar.map((key) => {
      const [codigo, index] = key.split('-');
  
      // Validar que respuesta[codigo] exista y sea un array
      if (!respuesta[codigo] || !Array.isArray(respuesta[codigo])) {
        console.error(`No se encontraron datos para el código ${codigo}`);
        return null;
      }
  
      // Validar que el índice exista en el array
      if (index >= respuesta[codigo].length) {
        console.error(`Índice ${index} fuera de rango para el código ${codigo}`);
        return null;
      }
  
      return respuesta[codigo][index];
    }).filter(Boolean); // Filtrar valores nulos
  
    if (horasMarcadas.length === 0) {
      console.error("No hay horas seleccionadas válidas para procesar.");
      return;
    }
  
    // Agrupar las horas por empleado
    const horasPorEmpleado = horasMarcadas.reduce((acc, marcaje) => {
      const codigo = marcaje.exp_codigo_alternativo;
      if (!acc[codigo]) {
        acc[codigo] = {
          CodEmpleado: marcaje.exp_codigo,
          CodigoAlternativo: codigo,
          Nombre: marcaje.exp_apellidos_nombres,
          HORASEXTRAS: {
            HESD: 0, // Hora Extra Simple Diurna
            HESM: 0, // Hora Extra Simple Mixta
            HEDD: 0, // Hora Extra Doble Diurna
            HEDM: 0, // Hora Extra Doble Mixta
          },
        };
      }
  
      // Clasificar y sumar las horas extras
      const horasExtras = parseFloat(marcaje.HorasExtra);
      const tipoHoraExtra = marcaje.Tipo_Hora_Extra; // Tipo de hora extra (SIMPLE o DOBLE)
      const jornada = marcaje.Jornada; // Jornada (DIURNA o MIXTA)
  
      if (!isNaN(horasExtras) && horasExtras > 0) {
        if (jornada === "Diurna") {
          if (tipoHoraExtra === "SIMPLE") {
            acc[codigo].HORASEXTRAS.HESD += horasExtras;
          } else if (tipoHoraExtra === "DOBLE") {
            acc[codigo].HORASEXTRAS.HEDD += horasExtras;
          }
        } else if (jornada === "Mixta") {
          if (tipoHoraExtra === "SIMPLE") {
            acc[codigo].HORASEXTRAS.HESM += horasExtras;
          } else if (tipoHoraExtra === "DOBLE") {
            acc[codigo].HORASEXTRAS.HEDM += horasExtras;
          }
        }
      }
  
      return acc;
    }, {});



    // Construir el JSON final para Datos_Recibidos 
    console.log(horasPorEmpleado);

    const datosRecibidos = {
      FechaIni: fechaSeleccionada.replace(/-/g, ''), // Eliminar guiones de FechaIni
      FechaFin: fechaSeleccionada2.replace(/-/g, ''), // Eliminar guiones de FechaFin
      Empleados: Object.values(horasPorEmpleado).map((empleado) => {
        // Calculamos las horas extras seleccionadas para ESTE empleado
        const horasExtrasSeleccionadas = calcularSumaHorasSeleccionadas(empleado.CodigoAlternativo);
        console.log(`Horas extras para ${empleado.Nombre}:`, horasExtrasSeleccionadas);
        return {
          CodEmpleado: empleado.CodEmpleado,
          CodigoAlternativo: empleado.CodigoAlternativo,
          Nombre: empleado.Nombre,
          HORASEXTRAS: [
            { HESD: horasExtrasSeleccionadas.diurnaSimple  },
            { HESM: horasExtrasSeleccionadas.mixtaSimple },
            { HEDD: horasExtrasSeleccionadas.diurnaDoble  },
            { HEDM: horasExtrasSeleccionadas.mixtaDoble  },
          ],
        };
      }),
    };
  
    // Convertir Datos_Recibidos a string
    const datosRecibidosString = JSON.stringify(datosRecibidos);
    console.log(datosRecibidos) 
  
    // Construir la solicitud POST
    const postRequest = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      User: {
        Codigo: "",
        UserNickName: "pierril",
      },
      Metodo: {
        NombreMetodo: "GeneracionHorasExtras",
        Datos_Recibidos: datosRecibidosString,
        Datos_Generados: "",
      },
    };
  
    console.log("Solicitud POST:", postRequest);
  
    // Aquí puedes hacer la llamada a la API para enviar la solicitud POST
    try {
      const response = await fetch("https://appcorp.parma.com.gt/API/ReceptorDatos", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postRequest),
      });
  
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
  
      const data = await response.json();
      console.log("Respuesta del servidor:", data);
      alert("Horas extras procesadas correctamente.");
    } catch (error) {
      console.error("Error:", error);
      alert("Hubo un error al procesar las horas extras.");
    }
  };
  

  const calcularMinutosFaltantesAcumulados = (codigo) => {
    if (!respuesta || !respuesta[codigo]) return { reales: 0, descontados: 0 };
  
    // 1. Calcular minutos reales acumulados (en negativo)
    let minutosReales = 0;
    
    respuesta[codigo].forEach((marcaje) => {
      const minutos = parseFloat(marcaje.Minutos_Faltantes);
      if (!isNaN(minutos) && minutos < 0) {
        minutosReales += minutos; // Acumulamos en negativo
      }
    });
  
    // 2. Aplicar fórmula de descuento sobre el valor absoluto
    let minutosADescontar = 0;
    const absMinutos = Math.abs(minutosReales);
    
    if (absMinutos >= 2 && absMinutos < 32) {
      minutosADescontar = -30; // Entre 2-31: -30
    } 
    else if (absMinutos >= 32) {
      // Redondeo a media hora superior
      const horas = Math.floor(absMinutos / 60);
      const minutosRestantes = absMinutos % 60;
      const mediasHorasExtra = Math.ceil(minutosRestantes / 30);
      minutosADescontar = -((horas * 2) + mediasHorasExtra) * 30;
    }
  
    return {
      reales: minutosReales,
      descontados: minutosADescontar
    };
  };

  const calcularMinutosFaltantes = (codigo) => {
    if (!respuesta || !respuesta[codigo]) return {
      totales: { reales: 0, descontados: 0 },
      porJornada: []
    };
  
    // Objeto para acumular por jornada
    const minutosPorJornada = {};
  
    // Acumuladores totales
    let minutosRealesTotales = 0;
    
    respuesta[codigo].forEach((marcaje) => {
      const minutos = parseFloat(marcaje.Minutos_Faltantes);
      if (!isNaN(minutos) && minutos < 0) {
        minutosRealesTotales += minutos;
        
        // Acumular por jornada
        const jornadaKey = marcaje.Fecha; // Puedes usar otro campo si prefieres
        if (!minutosPorJornada[jornadaKey]) {
          minutosPorJornada[jornadaKey] = {
            fecha: marcaje.Fecha,
            jornada: marcaje.Jornada || 'No especificada',
            minutos: 0
          };
        }
        minutosPorJornada[jornadaKey].minutos += minutos;
      }
    });
  
    // Calcular descuentos (tu lógica original)
    let minutosADescontar = 0;
    const absMinutos = Math.abs(minutosRealesTotales);
    
    if (absMinutos >= 2 && absMinutos < 32) {
      minutosADescontar = -30;
    } 
    else if (absMinutos >= 32) {
      const horas = Math.floor(absMinutos / 60);
      const minutosRestantes = absMinutos % 60;
      const mediasHorasExtra = Math.ceil(minutosRestantes / 30);
      minutosADescontar = -((horas * 2) + mediasHorasExtra) * 30;
    }
  
    // Convertir el objeto a array
    const jornadasArray = Object.values(minutosPorJornada);
  
    return {
      totales: {
        reales: minutosRealesTotales,
        descontados: minutosADescontar
      },
      porJornada: jornadasArray
    };
  }; 

  const calcularMinutosPorJornada = (codigo) => {
    if (!respuesta || !respuesta[codigo]) return {
      totalGeneral: { reales: 0, descontados: 0 },
      porJornada1: []
    };
  
    const jornadas = {
      Diurna: { reales: 0, descontados: 0 },
      Mixta: { reales: 0, descontados: 0 }
    };
  
    // Calcular minutos reales por jornada
    respuesta[codigo].forEach(marcaje => {
      if (!marcaje) return;
      
      const minutos = parseFloat(marcaje.Minutos_Faltantes) || 0;
      const jornada = marcaje.Jornada === "Mixta" ? "Mixta" : "Diurna";
      
      if (minutos < 0) {
        jornadas[jornada].reales += minutos;
      }
    });
  
    // Calcular minutos a descontar
    Object.keys(jornadas).forEach(tipo => {
      const absMinutos = Math.abs(jornadas[tipo].reales);
      
      if (absMinutos >= 2 && absMinutos < 32) {
        jornadas[tipo].descontados = -30;
      } 
      else if (absMinutos >= 32) {
        const horas = Math.floor(absMinutos / 60);
        const minutosRestantes = absMinutos % 60;
        const mediasHorasExtra = Math.ceil(minutosRestantes / 30);
        jornadas[tipo].descontados = -((horas * 2) + mediasHorasExtra) * 30;
      }
    });
  
    // Convertir a array (porJornada1)
    const porJornada1 = Object.keys(jornadas).map(tipo => ({
      tipo,
      reales: jornadas[tipo].reales,
      descontados: jornadas[tipo].descontados
    }));
  
    return {
      totalGeneral: {
        reales: porJornada1.reduce((sum, j) => sum + j.reales, 0),
        descontados: porJornada1.reduce((sum, j) => sum + j.descontados, 0)
      },
      porJornada1
    };
  };

  const calcularMinutosFaltantesYRestarHorasExtras = (codigo) => {
    let minutosFaltantesTotales = 0;
  
    // Sumar los minutos faltantes
    respuesta[codigo].forEach((marcaje) => {
      const minutosFaltantes = parseFloat(marcaje.Minutos_Faltantes);
      if (!isNaN(minutosFaltantes)) {
        minutosFaltantesTotales += minutosFaltantes;
      }
    });
  
    // Convertir minutos a horas
    const horasFaltantes = minutosFaltantesTotales / 60;
  
    // Obtener las horas extras seleccionadas
    const horasExtrasSeleccionadas = calcularSumaHorasSeleccionadas(codigo);
  
    // Restar las horas faltantes de las horas extras seleccionadas
    const horasExtrasFinales = {
      diurnaSimple: Math.max(0, parseFloat(horasExtrasSeleccionadas.diurnaSimple) - Math.abs(horasFaltantes)),
      diurnaDoble: Math.max(0, parseFloat(horasExtrasSeleccionadas.diurnaDoble) - Math.abs(horasFaltantes)),
      mixtaSimple: Math.max(0, parseFloat(horasExtrasSeleccionadas.mixtaSimple) - Math.abs(horasFaltantes)),
      mixtaDoble: Math.max(0, parseFloat(horasExtrasSeleccionadas.mixtaDoble) - Math.abs(horasFaltantes)),
  };
  
    return horasExtrasFinales;
  };

// Efecto para calcular minutos cuando cambian los datos
useEffect(() => {
  if (!respuesta) return;

  const nuevosMinutosReales = {};
  const nuevosMinutosDescontados = {};

  Object.keys(respuesta).forEach(codigo => {
    const calculo = calcularMinutosFaltantesAcumulados(codigo);
    nuevosMinutosReales[codigo] = calculo.reales;
    nuevosMinutosDescontados[codigo] = calculo.descontados;
  });

  setMinutosRealesAcumulados(nuevosMinutosReales);
  setMinutosDescontados(nuevosMinutosDescontados);
}, [respuesta]);

  return (
    <div>
      <h2>Marcajes de RRHH</h2>

      {/* Selector de fecha */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label htmlFor="fecha" className="form-label">DESDE:</label>
          <input
            type="date"
            id="fecha"
            className="form-control"
            value={fechaSeleccionada}
            onChange={(e) => setFechaSeleccionada(e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="fecha" className="form-label">HASTA:</label>
          <input
            type="date"
            id="fecha"
            className="form-control"
            value={fechaSeleccionada2}
            onChange={(e) => setFechaSeleccionada2(e.target.value)}
          />
        </div>
      </div>

      {/* Filtros */}
      <div className="row mb-3"> 
      <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por codigo"
            value={filtroCodigo}
            onChange={(e) => setFiltroCodigo(e.target.value)}
          />
        </div> 
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por nombre"
            value={filtroNombre}
            onChange={(e) => setFiltroNombre(e.target.value)}
          />
        </div> 
        </div>
  
        <div className="row mb-3">
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por compañía"
            value={filtroCompania}
            onChange={(e) => setFiltroCompania(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por unidad"
            value={filtroUnidad}
            onChange={(e) => setFiltroUnidad(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por puesto"
            value={filtroPuesto}
            onChange={(e) => setFiltroPuesto(e.target.value)}
          />
        </div> 
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por Area"
            value={filtroArea}
            onChange={(e) => setFiltroArea(e.target.value)}
          />
        </div>
        </div>
      
      <div className="mb-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => setFiltroHorasNegativas(!filtroHorasNegativas)}
        >
          {filtroHorasNegativas ? "Mostrar Todos" : "Mostrar Horas Negativas"}
        </button>
</div>
      {/* Botón y mensaje de error */}
      <div className="mb-3">
        <button
          className="btn btn-primary"
          onClick={enviarDatos}
          disabled={loading || !fechaSeleccionada}
        >
          {loading ? "Cargando..." : "Obtener Marcajes"}
        </button>
        {error && <p className="text-danger mt-2">{error}</p>}
      </div>

      {/* Botones para seleccionar y procesar */}
      <div className="mb-3">
        <button
          className="btn btn-secondary me-2"
          onClick={handleSeleccionarTodos}
        >
          {seleccionarTodos ? "Deseleccionar Todos" : "Seleccionar Todos"}
        </button>
        <button
          className="btn btn-success me-2"
          onClick={procesarSeleccionados}
          disabled={Object.keys(seleccionados).length === 0}
        >
          Procesar Seleccionados
        </button>
        <button
          className="btn btn-warning"
          onClick={procesarTodos}
        >
          Procesar Todos
        </button>
      </div>

      {/* Mostrar los datos agrupados y filtrados */}
      {respuesta && (
        <div style={{ marginTop: "20px" }}>
          {filtrarDatos(respuesta).map((codigo) => {
            const empleado = respuesta[codigo][0];
            const sumaHorasSeleccionadas = calcularSumaHorasSeleccionadas(codigo); // Suma de horas seleccionadas
            const minutosFaltantesAcumulados = calcularMinutosFaltantesAcumulados(codigo); 
            const minutosReales = minutosRealesAcumulados[codigo] || 0;
            const minutosDescontar = minutosDescontados[codigo] || 0; 
            const { totales, porJornada } = calcularMinutosFaltantes(codigo);
            const { totalGeneral, porJornada1 = [] } = calcularMinutosPorJornada(codigo) || {}; 
         

            


            return (
              <div
                key={codigo}
                style={{
                  marginBottom: "20px",
                  border: "1px solid #ddd",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  onClick={() => toggleDetalles(codigo)}
                >
                  <div>
                    <input
                      type="checkbox"
                      checked={!!seleccionados[codigo]}
                      onChange={() => handleSeleccionar(codigo)}
                      onClick={(e) => e.stopPropagation()} // Evita que el click en el checkbox abra/cierre los detalles
                    />
                    <strong>Código Alternativo:</strong> {empleado.exp_codigo_alternativo} <br />
                    <strong>Nombre:</strong> {empleado.exp_apellidos_nombres} <br />
                    <strong>Compañía:</strong> {empleado.cia_descripcion} <br />
                    <strong>Unidad:</strong> {empleado.uni_descripcion} <br />
                    <strong>Puesto:</strong> {empleado.pue_nombre}<br />
                    <strong> Area:</strong> {empleado.arf_nombre}
                  </div>
                  <div>{detallesAbiertos[codigo] ? "▲" : "▼"}</div>
                </div>

                {detallesAbiertos[codigo] && (
                  <div style={{ marginTop: "10px", maxHeight: "400px", overflowY: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Aprobar</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Fecha</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Jornada</th> 
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Dia</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Tipo de Dia</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Tipo Hora Extra</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Asueto</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Horas/Minutos</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Horas Extra</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>Minutos Faltantes</th>
                          {/* Columnas dinámicas para las horas */}
                          {Array.from({ length: 14 }, (_, i) => {
                              const eKey = `HoraE${i + 1}`;
                              const sKey = `HoraS${i + 1}`;
                              
                              // Verificar si hay datos en estas columnas (en cualquier registro)
                              const tieneDatos = respuesta[codigo].some(marcaje =>
                                (marcaje[eKey] && marcaje[eKey] !== "-") ||
                                (marcaje[sKey] && marcaje[sKey] !== "-")
                              );

                              // Mostrar siempre los primeros 5 segmentos, o hasta 14 si hay datos
                              const mostrarSegmento = (i < 5) || tieneDatos;

                              return mostrarSegmento ? (
                                <React.Fragment key={i}>
                                  <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>
                                    Hora Entrada {i + 1}
                                  </th>
                                  <th style={{ border: "1px solid #ddd", padding: "8px", backgroundColor: "#f2f2f2" }}>
                                    Hora Salida {i + 1}
                                  </th>
                                </React.Fragment>
                              ) : null;
                            })}
                        </tr>
                      </thead>
                      <tbody>
  {respuesta[codigo].map((marcaje, index) => (
    <tr 
      key={index} 
      style={{ 
        backgroundColor: marcaje.Estado === "Procesado" ? "#90EE90" : (index % 2 === 0 ? "#f9f9f9" : "#fff")
      }}
    >
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>
        <input
          type="checkbox"
          checked={!!horasSeleccionadas[`${codigo}-${index}`]}
          onChange={() => handleSeleccionarHora(codigo, index)}
        />
      </td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>{marcaje.Fecha}</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>{marcaje.Jornada}</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>{marcaje.Dia}</td> 
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>{marcaje.TipoDia}</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>{marcaje.Tipo_Hora_Extra}</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>{marcaje.Asueto}</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>{marcaje.Horas_Minutos}</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>{marcaje.HorasExtra}</td>
      <td style={{ border: "1px solid #ddd", padding: "8px" }}>{marcaje.Minutos_Faltantes}</td>

      {Array.from({ length: 14 }, (_, i) => {
          const eKey = `HoraE${i + 1}`;
          const sKey = `HoraS${i + 1}`;
          
          // Verificar si hay datos en estas columnas (en cualquier registro)
          const tieneDatos = respuesta[codigo].some(marcaje =>
            (marcaje[eKey] && marcaje[eKey] !== "-") ||
            (marcaje[sKey] && marcaje[sKey] !== "-")
          );

          // Mostrar siempre los primeros 5 segmentos, o hasta 14 si hay datos
          const mostrarSegmento = (i < 5) || tieneDatos;

          const renderBotonEditar = (codigo, index, segmento, tipo, hora, fecha) => {
            // No mostrar botón si es hora de entrada y el valor es '-'
            if (tipo === 'E' && hora === '-') {
              return null;
            }
            
            return (
              <button 
                className="btn btn-sm btn-outline-primary ms-2" 
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditarHora(codigo, index, segmento, tipo, hora, fecha);
                }}
              >
                Editar
              </button>
            );
          };

          return mostrarSegmento ? (
            <React.Fragment key={i}>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {marcaje[eKey] || "-"}
                {renderBotonEditar(codigo, index, i+1, 'E', marcaje[eKey], marcaje.Fecha)}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {marcaje[sKey] || "-"}
                {renderBotonEditar(codigo, index, i+1, 'S', marcaje[sKey], marcaje.Fecha)}
              </td>
            </React.Fragment>
          ) : null;
        })}
          </tr>
        ))}
      </tbody>
                    </table>
                  </div>
                )}

                {/* Mostrar el resumen de horas seleccionadas clasificadas */}

                <div style={{ marginTop: "10px" }}>
            <strong>Minutos Faltantes Acumulados:</strong> {minutosReales.toFixed(2)} minutos
          </div> 
          <div>
          <label>
              <input
                type="checkbox"
                checked={restarMinutosFaltantes}
                onChange={() => setRestarMinutosFaltantes(!restarMinutosFaltantes)}
              />
                 Restar minutos faltantes a las horas extras
            </label>
          </div>
                <div style={{ marginTop: "10px" }}>
                  <strong>Horas Extras Seleccionadas:</strong> <br />
                  - Diurnas Simples: {sumaHorasSeleccionadas.diurnaSimple} <br />
                  - Diurnas Dobles: {sumaHorasSeleccionadas.diurnaDoble} <br />
                  - Mixtas Simples: {sumaHorasSeleccionadas.mixtaSimple} <br />
                  - Mixtas Dobles: {sumaHorasSeleccionadas.mixtaDoble} <br />
                </div> 
             
                  <div>
                    <h5>Resumen de minutos faltantes</h5>
                    <p>Total acumulado: {totales.reales} minutos</p>
                    <p>Minutos a descontar: {totales.descontados} minutos</p>
                    
                    <h6>Detalle por jornada:</h6>
                    <ul>
                      {porJornada.map((jornada, index) => (
                        <li key={index}>
                          {jornada.fecha} - {jornada.jornada}: {jornada.minutos} minutos
                        </li>
                      ))}
                    </ul>
                  </div> 
                  <div className="mt-4">
                      <h5>Minutos faltantes por tipo de jornada</h5>
                      {porJornada1?.map((jornada1, index) => (
                          <div key={`jornada-${index}`}>
                            <h6>{jornada1.tipo || 'Jornada'}</h6>
                            <p>Faltantes: {jornada1.reales ?? 0}</p>
                            <p>Descontar: {jornada1.descontados ?? 0}</p>
                          </div>
                        ))}
                    </div> 
              </div>
            );
          })}
        </div>
      )}

      {/* Botón para procesar las horas seleccionadas */}
      <div className="mb-3">
        <button
          className="btn btn-info"
          onClick={procesarHorasSeleccionadas}
          disabled={Object.keys(horasSeleccionadas).length === 0}
        >
          Procesar Horas Seleccionadas
        </button>
      </div> 
      <div>
      {/* Todo tu contenido existente */}
      
      <ModalEditarHora
        show={showModal}
        handleClose={() => setShowModal(false)}
        horaEditando={horaEditando}
        handleSave={handleGuardarCambios}
      />
    </div>
    </div> 
    
  );
};

export default MarcajesRRHH;